import React from "react";
import { connect } from "react-redux";

import LastMobileAppVersions from "./LastMobileAppVersions";

const LastMobileAppVersionsContainer = props => {
  return <LastMobileAppVersions {...props} />;
};

const mapStateToProps = state => {
  const userInfos = state.userInfos || {};

  return {
    token: state.auth.token,
    clients: userInfos.clients || []
  };
};

export default connect(mapStateToProps)(LastMobileAppVersionsContainer);



// WEBPACK FOOTER //
// src/pages/mobileAppVersions/LastMobileAppVersions.container.js